// extracted by mini-css-extract-plugin
export default {"hideOnMobile":"_73dce6b9"};